import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {BehaviorSubject, Observable, tap} from 'rxjs';

import {TaskModel} from "../../models/task.model";
import {TaskStatusEnum} from "../../enums/task-status.enum";
import {environment} from "../../../../environments/environment";

@Injectable({
  providedIn: 'root'
})
export class TaskService {
  private baseUrl = `${environment.apiUrl}/task`;
  private taskCountSubject = new BehaviorSubject<number>(0);

  constructor(private readonly http: HttpClient) { }

  getAll(): Observable<TaskModel[]> {
    return this.http.get<TaskModel[]>(this.baseUrl).pipe(
      tap((actions) => {
        const size = actions.filter(a=>a.status == TaskStatusEnum.OPEN).length
        this.taskCountSubject.next(size);
      })
    );
  }

  getCount(): Observable<number> {
    return this.taskCountSubject.asObservable();
  }

  getById(id: number): Observable<TaskModel> {
    return this.http.get<TaskModel>(`${this.baseUrl}/${id}`);
  }

  create(dto: TaskModel): Observable<TaskModel> {
    return this.http.post<TaskModel>(this.baseUrl, dto);
  }

  update(id: number, dto: TaskModel): Observable<TaskModel> {
    return this.http.put<TaskModel>(`${this.baseUrl}/${id}`, dto);
  }

  delete(id: number): Observable<void> {
    return this.http.delete<void>(`${this.baseUrl}/${id}`);
  }

  lock(dto: TaskModel): Observable<TaskModel> {
    dto.status = TaskStatusEnum.LOCKED
    return this.update(dto.id, dto);
  }

  approve(dto: TaskModel): Observable<TaskModel> {
    dto.status = TaskStatusEnum.APPROVED
    return this.update(dto.id, dto);
  }

  decline(dto: TaskModel): Observable<TaskModel> {
    dto.status = TaskStatusEnum.DECLINED
    return this.update(dto.id, dto);
  }
}
